export default __webpack_public_path__ + "static/media/publicIcon.e79fe10b.svg";